var React = require('react');

function SendEmail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.518 32.765H15.7v8.842a4.827 4.827 0 007.545 3.987l5.173-3.526 3.002 4.007a4.828 4.828 0 008.606-2.006l7.2-38.343v-.002a4.826 4.826 0 00-7.301-4.99L2.959 23.844a4.828 4.828 0 002.559 8.922zM41.61 3.223a1.847 1.847 0 00-.094.055L4.549 26.386a1.828 1.828 0 00.969 3.379h15.935L41.61 3.223zM44.3 4.64L24.079 31.27l9.741 13.004a1.83 1.83 0 002.782.167 1.83 1.83 0 00.477-.926l7.2-38.345v-.003c.033-.175.04-.352.023-.527zM18.7 32.765v8.842a1.827 1.827 0 002.855 1.508l5.06-3.449-5.166-6.901h-2.75z"}));
}

SendEmail.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = SendEmail;

SendEmail.default = SendEmail;
